/* Minimal Services — REMOVED per design call.
   The Minimal template intentionally collapses Services into Booking so the
   visitor lands directly on the only interaction that matters (picking a
   sitting + tier). This stub redirects `/s/{slug}/services` to the booking
   flow so any inbound link, email signature, or stale bookmark still resolves
   gracefully instead of 404-ing. Nav links to "Services" are hidden from
   the Minimal Layout for the same reason. */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { tenantHref } from "@/lib/tenant";

export default function MinimalServices() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(tenantHref("/booking"), { replace: true });
  }, [navigate]);
  return null;
}
